import React, { useState, useEffect, useContext } from "react";
import { Context } from "../../../../Utility/ContextManager";
import { Modal, Row, Col, Form } from "react-bootstrap";
import envFile from "../../../../envFile";
import { formatDate, getRelevantLease, formatUSNumber } from "../../../../Utility";
import toast from "react-hot-toast";

const AccessToken = null;
const CreditCardPaymentModal = ({
  show,
  updateModalShow,
  resetValues,
  callbackFunction,
  propertyDetail,
  leases,
  dueAmount,
}) => {
  const [showPayabliIframe, setShowPayabliIframe] = useState(false);
  const { user } = useContext(Context);
  const isMember = user?.is_member === 1;
  const [selectedLeaseObj, setSelectedLeaseObj] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [inputValues, setInputValues] = useState({
    amount: "",
    date: "",
    checkedPayFull: true,
    checkedPayPartial: false,
  });

  // Event handler for messages from iframe
  useEffect(() => {
    const handleIframeMessage = (event) => {
      // Ensure the message is coming from a trusted origin
      // For production, replace "*" with the exact origin of the payment page for security.
      if (event.origin !== "https://paypages-sandbox.payabli.com") return;

      // Process the message data from the iframe
      const { status, message } = event.data;

      if (status === "success") {
        console.log("Payment was successful:", message);
        // Call callback function or handle success (e.g., close modal, update UI, etc.)
        callbackFunction(message);
        updateModalShow(false); // Close modal on success
      } else {
        console.error("Payment failed or unknown message:", message);
        // Handle failure case (optional)
      }
    };

    window.addEventListener("message", handleIframeMessage);

    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, [callbackFunction, updateModalShow]);

  const PayabliIframe = () => (
    <div>
      <iframe
        src={`https://paypages-sandbox.payabli.com/4b9e2354ff/1726466976566?billingEmail=daniel.lopez+testTenant1@arrivo.ai`}
        name="payment_page"
        height="1000"
        width="100%"
        title="Payment Page"
      ></iframe>
    </div>
  );
  const beginCreditCardPayment = () => {
    let leaseId;
    //ALL PAYMENT LEASE ID = 1445599
    if (isMember) {
      //if full balance selected set lease id to all payment lease id, else set to selected lease id
      leaseId = inputValues?.checkedPayFull ? 1445599 : selectedLeaseObj?.id;
    } else {
      leaseId = propertyDetail?.lease_id;
    }
    if (!leaseId) {
      toast.error(isMember ? "Please select a lease to pay" : "Unable to find lease");
      return;
    }

    /**
     * 
     *const config = {
      leaseId: propertyDetail?.lease_id,
      customerId: user?.id,
      firstName: user?.first_name,
      lastName: user?.last_name,
      email: user?.email,
      phone: user?.phone,
    };
     */

    const config = {
      autopay: 0,
      card: 1,
      ach: 0,
      callbackUrl: `${envFile.PAYABLI_CALLBACK_URL}`,
      invoiceNumber: leaseId?.toString(),
      company: "Arrivo",
      payor: {
        firstName: user?.first_name,
        lastName: user?.last_name,
        customerNumber: user?.id?.toString(),
        billingEmail: user?.email,
        invoiceNumber: leaseId?.toString(),
        companyName: "Arrivo",
        //additional_leaseid: leaseId?.toString(),
      },
    };

    // Function to convert config object into query string

    // Function to convert config object into query string
    const buildQueryString = (config) => {
      const params = [];

      // Loop through the main config object
      for (const [key, value] of Object.entries(config)) {
        if (typeof value === "object") {
          // Handle nested objects (e.g., payor)
          for (const [subKey, subValue] of Object.entries(value)) {
            if (subValue !== undefined && subValue !== null) {
              params.push(`${encodeURIComponent(subKey)}=${encodeURIComponent(subValue)}`);
            }
          }
        } else if (value !== undefined && value !== null) {
          // Handle main-level properties
          params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      }

      // Join params with '&' to create the query string
      return params.join("&");
    };

    let amountString;
    if (!inputValues?.checkedPayFull || !isMember) {
      amountString = `?amount=${dueAmount}&editamount=true&`;
    } else {
      amountString = `?amount=${dueAmount}&editamount=false&`;
    }
    // Usage
    const queryString = buildQueryString(config);
    const url = `${envFile.PAYABLI_PAYPAGE_API_LINK}/${propertyDetail?.paypoint_id}/${propertyDetail?.subdomain}${amountString}${queryString}`;
    window.open(url);
  };

  const groupLeasesByUnit = (leases) => {
    const grouped = leases?.reduce((acc, lease) => {
      // Group leases by property_unit_id
      if (!acc[lease.property_unit_id]) {
        acc[lease.property_unit_id] = [];
      }
      acc[lease.property_unit_id].push(lease);
      return acc;
    }, {});

    const relevantLeases = Object.keys(grouped)?.reduce((acc, propertyUnitId) => {
      // Select the most relevant lease for each property unit ID
      acc[propertyUnitId] = getRelevantLease(grouped[propertyUnitId])[0] || {};
      return acc;
    }, {});
    return relevantLeases;
  };

  const getMemberAccountBalance = () => {
    if (inputValues?.checkedPayFull) {
      const amount = dueAmount > 0 ? formatUSNumber(dueAmount) : "-";
      return amount;
    } else {
      const amount =
        leases?.find((lease) => lease?.id === Number(selectedLeaseObj?.id))?.available_balance < 0
          ? formatUSNumber(
              Math.abs(leases?.find((lease) => lease?.id === Number(selectedLeaseObj?.id))?.available_balance)
            )
          : "$0";
      return amount;
    }
  };

  const MemberPaymentInformation = () => {
    return (
      <>
        {inputValues?.checkedPayPartial && (
          <>
            <h5 className="mt-4">Select Space ID</h5>
            <div className="select">
              <div className="select">
                <select
                  value={selectedLeaseObj?.id}
                  onChange={(e) => {
                    const lease = leases?.find((lease) => lease.id === Number(e.target.value));
                    setSelectedLeaseObj(lease);
                  }}
                >
                  {!selectedLeaseObj && <option value="">Select a space</option>} {/* Add a default option */}
                  {Object.entries(groupLeasesByUnit(leases?.filter((lease) => lease?.is_expired !== 1) || [])).map(
                    ([propertyUnitId, lease]) => (
                      // Assuming you want to display the first lease in each group for simplicity
                      <option key={lease.id} value={lease.id}>
                        {lease.unit_name} ( $
                        {Number(lease.available_balance) < 0 ? Number(lease.available_balance) : "0"})
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>
          </>
        )}

        <div className="accordion accordion-flush accordion-v2 mt-4" id="accordion1">
          <div className="accordion-item">
            <h5 className="mt-4 mb-2 card-title">Current Account Balance</h5>
            <div>
              <span>
                <strong className="price mt-4" style={{ fontSize: "28px" }}>
                  {selectedLeaseObj?.id !== "" && isMember
                    ? getMemberAccountBalance()
                    : dueAmount > 0
                    ? formatUSNumber(dueAmount)
                    : "-"}
                </strong>
              </span>
            </div>
            <h5 className="mt-4 mb-2 card-title">Your bill is due on</h5>
            <div>
              <span>
                <strong className="price mt-4" style={{ fontSize: "16px" }}>
                  {propertyDetail?.upcoming_due_date ? (
                    <span>{formatDate(propertyDetail.upcoming_due_date)}</span>
                  ) : (
                    "There is nothing for you to pay"
                  )}
                </strong>
              </span>
            </div>
            {user?.restricted_status !== "SUSPENDED" ? (
              <>
                <Row className="mt-3">
                  <Col xl={6}>
                    {/* LARGE SCREEN */}

                    <label className={` ${inputValues?.checkedPayFull ? "primary-text" : ""}`}>Pay Full Balance</label>
                    <Form className="d-none d-xl-block">
                      <Form.Check type="radio" id={`full-balance-radio`}>
                        <Form.Check.Input
                          type="radio"
                          isValid={inputValues?.checkedPayFull ? true : false}
                          name="paymentOption"
                          checked={inputValues?.checkedPayFull}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setInputValues({ ...inputValues, checkedPayFull: true, checkedPayPartial: false });
                              if (isMember) {
                                setSelectedDate(new Date());
                              }
                            }
                          }}
                        />
                      </Form.Check>
                    </Form>
                  </Col>
                  <Col xl={6}>
                    {/* SHWO ON LARGE SCREEN SCREEN */}

                    <Form className="d-none d-xl-block">
                      <label className={`mx-2  ${inputValues?.checkedPayPartial ? "primary-text" : ""}`}>
                        Pay Partial
                      </label>
                      <Form.Check type="radio" id={`partial-balance-radio`}>
                        <Form.Check.Input
                          type="radio"
                          isValid={inputValues?.checkedPayPartial ? true : false}
                          name="paymentOption"
                          checked={inputValues?.checkedPayPartial}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setInputValues({
                                ...inputValues,
                                checkedPayFull: false,
                                checkedPayPartial: true,
                              });
                            }
                          }}
                        />
                      </Form.Check>
                    </Form>
                  </Col>
                </Row>
                {user?.restricted_status !== "FULL PAYMENT" && (
                  <Row className="mt-3">
                    <Col xl={6}>
                      <label>
                        {/* LARGE SCREEN */}

                        {/* SMALL SCREEN */}
                      </label>
                    </Col>
                    {/*
          <input
            className="form-control"
            type="text"
            id="amount"
            value={`$${inputAmount}`}
            onChange={(e) => {
              const value = formatCurrency(e);
              if (value) {
                setInputAmount(value);
              }
            }}
          />
          */}
                  </Row>
                )}{" "}
              </>
            ) : (
              <div>
                <h3 className="mt-4 text-danger">Suspended</h3>
                <p className="card-title">Please contact your Property Manager</p>
              </div>
            )}
          </div>
          {/*
    <div className="accordion-item">
      <h2 className="accordion-header" id="headingTwo">
        <button
          className="accordion-button collapsed schedule-date-btn"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTwo"
          aria-expanded="false"
          aria-controls="collapseTwo"
          data-cy="payfrom"
        >
          Pay From
        </button>
      </h2>
      <div
        id="collapseTwo"
        className="accordion-collapse collapse"
        aria-labelledby="headingTwo"
        data-bs-parent="#accordion1"
      >
        <div className="accordion-body">
          <div className="select">
            <select
              data-cy="bankaccount"
              defaultValue={
                bankAccounts?.find((item) => item?.default_bank_account === 1)
                  ? JSON.stringify(bankAccounts.find((item) => item?.default_bank_account === 1))
                  : "hide"
              }
              onChange={(e) => {
                e.preventDefault();
                if (e.target.value) {
                  setSelectedBankAccount(JSON.parse(e.target.value));
                  setAutoPaymentBank();
                }
              }}
            >
              <option disabled value="hide">
                {bankAccounts.length > 0 ? "Select Bank Account" : "You have not added any bank account"}
              </option>

              {bankAccounts
                ?.filter((bank) => bank.status !== "pending_manual_verification")
                ?.map((bank, index) => (
                  <option key={index} value={JSON.stringify(bank)}>
                    **** **** **** {bank?.account_number}
                  </option>
                ))}
            </select>
          </div>
          <div className="text-center py-3 fw-bold">or</div>
          <AddBankAccount
            getAllBankAccounts={getAllBankAccounts}
            setLoading={setLoading}
            isFromDashboard={true}
          />
        </div>
      </div>
    </div>
*/}
        </div>
      </>
    );
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        updateModalShow(false);
      }}
      className="modal-style-1 w-100"
      size="xl"
    >
      <Modal.Header>
        <Modal.Title as="h3" className="w-100 text-center">
          Continue to Pay with Card
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {showPayabliIframe ? (
          <PayabliIframe />
        ) : (
          <>
            <div className="text-center">
              {isMember && <MemberPaymentInformation />}
              <p className="mb-3">
                Please note that all credit card payments will incur a fee of 2.9% + $0.30 per transaction.
              </p>
            </div>
            <Row>
              <Col xxl={6} xl={12}>
                <button
                  type="button"
                  className="btn btn-secondary w-100"
                  onClick={() => {
                    resetValues();
                    updateModalShow(false);
                  }}
                >
                  Back
                </button>
              </Col>
              <Col xxl={6} xl={12}>
                <button
                  onClick={() => {
                    //setShowPayabliIframe(true);
                    beginCreditCardPayment();
                  }}
                  type="button"
                  className="btn btn-primary w-100 mt-4 mt-xl-0"
                  data-cy="continue"
                >
                  Continue To Payment
                </button>
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CreditCardPaymentModal;
